module.exports = __webpack_public_path__ + "static/bai_fct3-e6a4c1ec04378e5ca93db2dca865110e.jpg";